import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

import {
    PageHeader,
    Panel,
    InfoRow,
    PrimaryButton,
    DarkButton,
} from "../components/ui/AdminUI";

const ClientPage = () => {
    const navigate = useNavigate();

    const [client, setClient] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const token =
            localStorage.getItem("authToken") ||
            localStorage.getItem("token") ||
            localStorage.getItem("jwt");

        if (!token) {
            navigate("/login");
            return;
        }

        const loadClient = async () => {
            try {
                const { data } = await api.get("/Client/me");
                setClient(data);
            } catch (err) {
                setError(
                    err?.response?.data?.message ||
                    err?.message ||
                    "Error loading client profile."
                );
            } finally {
                setLoading(false);
            }
        };

        loadClient();
    }, [navigate]);

    const logout = () => {
        [
            "authToken",
            "token",
            "jwt",
            "role",
        ].forEach((k) => {
            localStorage.removeItem(k);
            sessionStorage.removeItem(k);
        });

        navigate("/login");
    };

    if (loading)
        return (
            <div className="p-8 text-slate-600">
                Loading client profile...
            </div>
        );

    if (error)
        return (
            <div className="rounded-xl border border-red-300 bg-red-50 p-5 text-red-700">
                {error}
            </div>
        );

    return (
        <div className="space-y-6">

            <PageHeader
                title="Customer Account"
                subtitle="Manage your profile, orders, shipments and invoices."
                action={
                    <DarkButton onClick={logout}>
                        Logout
                    </DarkButton>
                }
            />

            {client ? (
                <>
                    <Panel
                        title="Client Information"
                        subtitle="Basic account details."
                    >
                        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">

                            <InfoRow
                                label="Client ID"
                                value={client.id}
                            />

                            <InfoRow
                                label="Name"
                                value={
                                    client.companyName ||
                                    `${client.name ?? ""} ${client.lastName ?? ""}`.trim() ||
                                    "—"
                                }
                            />

                            <InfoRow
                                label="Email"
                                value={client.email}
                            />

                            <InfoRow
                                label="Phone"
                                value={client.phoneNumber}
                            />

                        </div>
                    </Panel>

                    <Panel
                        title="Quick Actions"
                        subtitle="Frequently used customer functions."
                    >

                        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">

                            <PrimaryButton
                                onClick={() => navigate("/client/orders")}
                            >
                                📦 My Orders
                            </PrimaryButton>

                            <PrimaryButton
                                onClick={() => navigate("/client/orders/create")}
                            >
                                ➕ Create Order
                            </PrimaryButton>

                            <PrimaryButton
                                onClick={() => navigate("/client/shipments")}
                            >
                                🚚 My Shipments
                            </PrimaryButton>

                            <PrimaryButton
                                onClick={() => navigate("/client/invoices")}
                            >
                                🧾 My Invoices
                            </PrimaryButton>

                            <PrimaryButton
                                onClick={() => navigate("/client/iot-tracking")}
                            >
                                📡 IoT Tracking
                            </PrimaryButton>

                            <PrimaryButton
                                onClick={() => navigate("/client/delivery-price")}
                            >
                                💰 Delivery Price
                            </PrimaryButton>

                        </div>

                    </Panel>
                </>
            ) : (
                <Panel title="Customer">
                    <p className="text-slate-500">
                        Client profile not found.
                    </p>
                </Panel>
            )}
        </div>
    );
};

export default ClientPage;